module.exports = __webpack_public_path__ + "img/Vietnam.de233a2f.svg";